<div class="popup-container">

  <!-- HEADER -->
  <div class="header">
    <h5 class="building_data">Building Images</h5>
    <button class="close-btn" (click)="close()">✖</button>
  </div>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="text-center p-4">
    Loading images...
  </div>

  <!-- CONTENT -->
  <div *ngIf="!isLoading">

    <!-- IF VALID IMAGES EXIST -->
    <div *ngIf="validImages.length > 0; else noImageBlock">

      <div class="carousel-wrapper">

        <img
          [src]="validImages[currentIndex]"
          class="carousel-img" />

        <!-- PREV -->
        <button class="nav-btn left"
                (click)="prev()"
                [disabled]="currentIndex === 0">
          ‹
        </button>

        <!-- NEXT -->
        <button class="nav-btn right"
                (click)="next()"
                [disabled]="currentIndex === validImages.length - 1">
          ›
        </button>

        <!-- IMAGE COUNTER -->
        <div class="image-counter">
          {{ currentIndex + 1 }} / {{ validImages.length }}
        </div>

      </div>

    </div>

    <!-- NO IMAGE BLOCK -->
    <ng-template #noImageBlock>
      <div class="text-center p-4">
        <img src="assets/image/building_image.svg" width="200">
        <p>No Images Available</p>
      </div>
    </ng-template>

  </div>

</div>
